// Mock data for DD Financial Services By Deepak Chart Analysis

export const heroData = {
  heading: "Professional Technical Chart Analysis for Smart Traders",
  subheading: "Accurate Research on Nifty, Bank Nifty, Stocks & Forex Trading",
  ctaPrimary: "View Technical Research",
  ctaSecondary: "Open Trading Account",
  affiliateLink: "https://affs.click/nkAgL",
  forexFundedLink: "https://thefundedroom.com/?ref=90EZ1H98",
  premiumSubscriptionLink: "https://cosmofeed.com/vig/66544b48b0ccbd0013a69a96",
  zuperiorLink: "https://dashboard.zuperior.com/login?referralCode=IB540OSG",
  vantageLink: "https://vigco.co/la-com-inv/DAIVIK",
  elefinLink: "https://my.elefin.com/register?ref=K9II-O6JI0W",
  indiabullsDematLink: "https://indiabullssecurities.onelink.me/Kaqz/t9cwyib4",
  profileImage: "/images/deepak.jpeg?v=2"
};

export const aboutData = {
  title: "About DD Financial Services By Deepak Chart Analysis",
  description: "हम एक professional technical research platform हैं जो chart patterns, indicators, price action और trend analysis पर focus करता है। हमारा मकसद है traders को disciplined, accurate और risk management based analysis provide करना। Stock market और Forex Trading में success के लिए proper research और technical knowledge जरूरी है।"
};

export const indusIndNipponData = {
  companyName: "IndusInd Nippon Life Insurance",
  name: "DIPAK",
  designation: "Senior Managing Partner",
  employeeCode: "70671439",
  enquiryNumber: "8299568289",
  enquiryTel: "tel:+918299568289",
  enquiryWhatsApp: "https://wa.me/918299568289",
  idCardImage: "/images/indusind-id-card.jpeg",
  tagline: "Secure Your Family's Future with Trusted Life Insurance",
  description: "Protect what matters most. Get expert guidance on life insurance, savings plans, retirement planning और wealth protection from a certified Senior Managing Partner at IndusInd Nippon Life Insurance.",
  features: [
    { title: "Life Insurance Plans", description: "Term insurance, whole life, और comprehensive family protection plans" },
    { title: "Savings & Investment", description: "ULIPs, endowment plans और guaranteed return schemes for wealth creation" },
    { title: "Retirement Planning", description: "Secure your golden years with tailored pension और annuity solutions" }
  ]
};

export const servicesData = [
  {
    id: 1,
    title: "Intraday Technical Analysis",
    description: "Daily market analysis with precise entry and exit levels for intraday trading",
    icon: "TrendingUp"
  },
  {
    id: 2,
    title: "Swing & Positional Trade Research",
    description: "Medium to long-term trade ideas based on strong technical patterns",
    icon: "BarChart3"
  },
  {
    id: 3,
    title: "Nifty & Bank Nifty Chart Levels",
    description: "Key support and resistance levels for index trading",
    icon: "LineChart"
  },
  {
    id: 4,
    title: "Forex Trading Analysis",
    description: "Currency pairs analysis with precise entry/exit levels for forex market",
    icon: "DollarSign"
  },
  {
    id: 5,
    title: "Support & Resistance Analysis",
    description: "Critical price zones identified through technical chart analysis",
    icon: "Activity"
  },
  {
    id: 6,
    title: "Risk-Reward Based Strategy",
    description: "Every trade idea comes with proper stop-loss and target levels",
    icon: "Shield"
  },
  {
    id: 7,
    title: "Educational Content",
    description: "Learn technical analysis concepts and improve your trading skills",
    icon: "BookOpen"
  }
];

export const technicalResearchData = [
  {
    id: 1,
    title: "Nifty 50 Analysis",
    date: "Today's Market Outlook",
    analysis: "Nifty is trading near key resistance zone of 22,500. Watch for breakout above this level for bullish momentum. Support at 22,200 level.",
    entry: "22,520",
    target: "22,750 - 22,900",
    stopLoss: "22,350",
    imageUrl: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&auto=format&fit=crop"
  },
  {
    id: 2,
    title: "Bank Nifty Analysis",
    date: "Intraday Levels",
    analysis: "Bank Nifty showing bullish divergence on hourly charts. Key level to watch is 48,000. Strong support at 47,500 zone.",
    entry: "48,050",
    target: "48,400 - 48,600",
    stopLoss: "47,800",
    imageUrl: "https://images.unsplash.com/photo-1642790106117-e829e14a795f?w=800&auto=format&fit=crop"
  },
  {
    id: 3,
    title: "EUR/USD Forex Analysis",
    date: "Today's Setup",
    analysis: "EUR/USD showing strong bullish momentum above 1.0850. Watch for continuation towards 1.0920. Key support at 1.0800 zone.",
    entry: "1.0860",
    target: "1.0920 - 1.0950",
    stopLoss: "1.0825",
    imageUrl: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&auto=format&fit=crop"
  },
  {
    id: 4,
    title: "BTC/USD Analysis",
    date: "Crypto Setup",
    analysis: "Bitcoin CMP ~$97,500 — bullish structure on 4H chart, holding above 200-EMA. Breakout above $98,500 opens the way for $100K psychological level. Immediate support zone at $95,800.",
    entry: "97,600",
    target: "99,200 - 100,500",
    stopLoss: "95,400",
    imageUrl: "https://images.unsplash.com/photo-1518546305927-5a555bb7020d?w=800&auto=format&fit=crop"
  },
  {
    id: 5,
    title: "XAU/USD (Gold) Analysis",
    date: "Today's Setup",
    analysis: "Gold CMP ~$2,865 — strong bullish trend continues with higher-highs formation. Buy on dips towards $2,850 zone for continuation. Break above $2,880 targets $2,910 - $2,935 zone.",
    entry: "2,868",
    target: "2,905 - 2,935",
    stopLoss: "2,845",
    imageUrl: "https://images.unsplash.com/photo-1610375461246-83df859d849d?w=800&auto=format&fit=crop"
  },
  {
    id: 6,
    title: "Swing Trade Idea",
    date: "This Week",
    analysis: "Breakout pattern forming in IT sector stocks. Strong accumulation visible on charts with increasing volumes.",
    entry: "CMP",
    target: "8-12% upside",
    stopLoss: "5% below entry",
    imageUrl: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&auto=format&fit=crop"
  },
  {
    id: 7,
    title: "MSTR — Educational Watch",
    date: "Long-Term Hold",
    analysis: "MicroStrategy (MSTR) — Educational long-term watch. Strong Bitcoin-linked balance sheet play. Entry level around $93, patient investors can hold for $500+ multi-year targets. Not a short-term trade — accumulation and holding required.",
    entry: "$93",
    target: "$500++",
    stopLoss: "Hold Long Term",
    imageUrl: "https://images.unsplash.com/photo-1642790106117-e829e14a795f?w=800&auto=format&fit=crop"
  }
];

export const whyChooseUsData = [
  {
    id: 1,
    title: "100% Technical Analysis",
    description: "Pure chart-based research without any bias or manipulation",
    icon: "Target"
  },
  {
    id: 2,
    title: "No False Promises",
    description: "हम guarantee नहीं देते, सिर्फ accurate technical research provide करते हैं",
    icon: "CheckCircle2"
  },
  {
    id: 3,
    title: "Data-Driven Decisions",
    description: "Every analysis backed by price action, indicators, and volume data",
    icon: "Database"
  },
  {
    id: 4,
    title: "Beginner Friendly",
    description: "Easy to understand format for both beginners and experienced traders",
    icon: "Users"
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Rajesh Kumar",
    role: "Intraday Trader",
    content: "बहुत accurate analysis मिलता है। Entry और exit levels काफी precise होते हैं। Technical analysis की quality excellent है।",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "Swing Trader",
    content: "Professional approach और clear risk management strategy. No fake promises, only genuine technical research.",
    rating: 5
  },
  {
    id: 3,
    name: "Amit Patel",
    role: "Positional Investor",
    content: "Chart analysis की quality top-notch है। Support और resistance levels बहुत accurate होते हैं।",
    rating: 5
  }
];

export const contactData = {
  whatsapp: "+91 9838382511",
  whatsappLink: "https://bit.ly/3xWoDCg",
  telegram: "@deepakchartanalysis",
  email: "info@deepakchartpro.com",
  socialMedia: {
    youtube: "https://youtube.com/@deepakchartanalysis?si=paeNIgkafXhdo8WQ",
    twitter: "#",
    instagram: "#",
    facebook: "#"
  }
};

export const youtubeData = {
  channelName: "Deepak Chart Analysis",
  channelHandle: "@deepakchartanalysis",
  channelUrl: "https://youtube.com/@deepakchartanalysis?si=paeNIgkafXhdo8WQ",
  description: "Daily chart analysis, trading setups, educational videos aur market insights — sab kuch FREE on YouTube. Subscribe karo aur bell icon dabao for instant notifications.",
  features: [
    "Daily Market Analysis",
    "Live Trading Sessions",
    "Educational Content",
    "Strategy Breakdowns"
  ]
};

export const upcomingAppData = {
  name: "Deepak Chart Analysis Mobile Application",
  tagline: "Coming Soon on Google Play Store",
  description: "DD Financial Services By Deepak Chart Analysis ki official mobile app launch hone wali hai! Get real-time charts, trade signals, market alerts, educational videos — all in one place, right in your pocket.",
  features: [
    { title: "Real-Time Signals", description: "Instant trade alerts direct to your phone" },
    { title: "Live Market Analysis", description: "Daily charts, levels और research reports" },
    { title: "Educational Hub", description: "Video courses, webinars और strategy guides" },
    { title: "Portfolio Tracker", description: "Track your trades और P&L in one dashboard" }
  ],
  status: "LAUNCHING SOON"
};


export const disclaimerData = {
  title: "Disclaimer",
  points: [
    "Stock market investments are subject to market risks. Please read all research documents carefully before trading.",
    "We provide only technical research and educational content, not investment advice or guaranteed returns.",
    "Past performance is not indicative of future results. All trading decisions are your own responsibility.",
    "Please consult with a certified financial advisor before making any investment decisions.",
    "All analysis is for educational and research purposes only. Trade at your own risk."
  ]
};